import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/deploy/src/app/bio-well-device/components/BioWellDeviceInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/deploy/src/components/common/Header.tsx");
